/* Mario Games · diseño C: banner, pestañas, ficha y orden */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function iniciarBanner(root) {
    if (root.dataset.mgListo) return;
    root.dataset.mgListo = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('.sl'));
    var pests = Array.prototype.slice.call(root.querySelectorAll('.pest'));
    var ms = parseInt(root.dataset.intervalo, 10) || 5200;
    root.style.setProperty('--mg-dur', ms + 'ms');
    var i = 0;
    var reloj = null;
    var pausa = reducido || slides.length < 2;
    var boton = root.querySelector('[data-mg-pausa]');

    function marcarPausa() {
      root.classList.toggle('pausa', pausa);
      if (boton) {
        boton.setAttribute('aria-label', pausa ? 'Reanudar' : 'Pausar');
        boton.setAttribute('aria-pressed', pausa ? 'true' : 'false');
      }
    }
    function programar() {
      clearInterval(reloj);
      if (!pausa && !document.hidden) {
        reloj = setInterval(function () { mostrar(i + 1); }, ms);
      }
    }
    function mostrar(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('on', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if ('inert' in s) s.inert = !on;
      });
      pests.forEach(function (p, k) {
        var on = k === i;
        p.classList.remove('on');
        if (on) { void p.offsetWidth; p.classList.add('on'); }
        p.setAttribute('aria-current', on ? 'true' : 'false');
      });
      programar();
    }
    var prev = root.querySelector('[data-mg-prev]');
    var next = root.querySelector('[data-mg-next]');
    if (prev) prev.addEventListener('click', function () { mostrar(i - 1); });
    if (next) next.addEventListener('click', function () { mostrar(i + 1); });
    if (boton) boton.addEventListener('click', function () { pausa = !pausa; marcarPausa(); programar(); });
    pests.forEach(function (p, k) { p.addEventListener('click', function () { mostrar(k); }); });
    document.addEventListener('visibilitychange', programar);
    root.addEventListener('shopify:block:select', function (e) {
      var k = slides.indexOf(e.target.closest ? e.target.closest('.sl') : null);
      if (k > -1) { pausa = true; marcarPausa(); mostrar(k); }
    });
    marcarPausa();
    mostrar(0);
  }

  function iniciarFiltro(sec) {
    if (sec.dataset.mgListo) return;
    sec.dataset.mgListo = '1';
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('[data-filtro]'));
    var cards = Array.prototype.slice.call(sec.querySelectorAll('[data-compat]'));
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var f = t.dataset.filtro;
        tabs.forEach(function (x) {
          var on = x === t;
          x.classList.toggle('on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        cards.forEach(function (c) { c.hidden = !(f === 'todos' || c.dataset.compat === f); });
      });
    });
  }

  function dinero(c) {
    var n = c / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function iniciarFicha(f) {
    if (f.dataset.mgListo) return;
    f.dataset.mgListo = '1';
    var nodo = f.querySelector('[data-mg-datos]');
    if (!nodo) return;
    var datos = JSON.parse(nodo.textContent);
    var q = function (s) { return f.querySelector(s); };
    var el = {
      lab: q('[data-mg-lab]'), precio: q('[data-mg-precio]'), der: q('[data-mg-der]'),
      ahorro: q('[data-mg-ahorro]'), sello: q('[data-mg-sello]'), selloTxt: q('[data-mg-sello-txt]'),
      wa: q('[data-mg-wa]'), waTxt: q('[data-mg-watxt]')
    };
    function aplicar(v) {
      if (!v) return;
      if (el.lab) el.lab.textContent = v.op || datos.etiqueta;
      if (el.precio) el.precio.textContent = dinero(v.precio);
      var hay = datos.eshop > v.precio;
      if (el.der) el.der.hidden = !hay;
      if (el.sello) el.sello.hidden = !hay;
      if (hay) {
        if (el.ahorro) el.ahorro.textContent = 'Ahorras ' + dinero(datos.eshop - v.precio);
        if (el.selloTxt) el.selloTxt.textContent = '-' + (100 - Math.round(v.precio * 100 / datos.eshop)) + '%';
      }
      var opcion = v.op ? ' en ' + v.op.toLowerCase() : '';
      var msg = 'Hola, me interesa ' + datos.titulo + opcion + ' (' + dinero(v.precio) + ')';
      if (el.wa) el.wa.href = 'https://wa.me/' + datos.wa + '?text=' + encodeURIComponent(msg);
      if (el.waTxt) el.waTxt.textContent = v.op ? 'Pedir ' + v.op.toLowerCase() : 'Pedir';
    }
    Array.prototype.slice.call(f.querySelectorAll('input[name="mg-opcion"]')).forEach(function (r) {
      r.addEventListener('change', function () {
        Array.prototype.slice.call(f.querySelectorAll('.op')).forEach(function (o) {
          o.classList.toggle('on', o.contains(r) && r.checked);
        });
        var v = datos.variantes.filter(function (x) { return String(x.id) === r.value; })[0];
        aplicar(v);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      });
    });
    var esc = q('.escena');
    if (esc && !reducido && window.matchMedia('(hover: hover)').matches) {
      var raf = 0, nx = 0.5, ny = 0.5;
      esc.addEventListener('pointermove', function (e) {
        var r = esc.getBoundingClientRect();
        nx = (e.clientX - r.left) / r.width;
        ny = (e.clientY - r.top) / r.height;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          esc.style.setProperty('--rx', ((0.5 - ny) * 16).toFixed(1) + 'deg');
          esc.style.setProperty('--ry', ((nx - 0.5) * 22).toFixed(1) + 'deg');
          esc.style.setProperty('--bx', Math.round(100 - nx * 100) + '%');
        });
      });
      esc.addEventListener('pointerleave', function () {
        esc.style.setProperty('--rx', '0deg');
        esc.style.setProperty('--ry', '0deg');
        esc.style.setProperty('--bx', '50%');
      });
    }
  }

  function iniciarOrden(s) {
    if (s.dataset.mgListo) return;
    s.dataset.mgListo = '1';
    s.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }

  function iniciar(raiz) {
    var r = raiz || document;
    Array.prototype.slice.call(r.querySelectorAll('[data-mg-slider]')).forEach(iniciarBanner);
    Array.prototype.slice.call(r.querySelectorAll('[data-mg-filtro]')).forEach(iniciarFiltro);
    Array.prototype.slice.call(r.querySelectorAll('[data-mg-ficha]')).forEach(iniciarFicha);
    Array.prototype.slice.call(r.querySelectorAll('[data-mg-orden]')).forEach(iniciarOrden);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  else iniciar();
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
